// extracted by css-extract-rspack-plugin
module.exports =  {"item":"Item-aK6H__item","content-label":"Item-E0RI__content-label","navigation-icon":"Item-jv_8__navigation-icon"};